import { withTheme } from '@emotion/react'
import styled from '@emotion/styled';

/**
 * Button
 * @props   {string} text  Text for the button
 */


const StyledButton = styled.button`
  align-self: center;
  background: ${props => props.theme.colors.primary1};
  border: none;
  border-radius: 6px;
  color: ${props => props.theme.colors.contrast2};
  cursor: pointer;
  font-family: ${props => props.theme.fonts.primary};
  font-size: ${props => props.theme.fontSizes.std};
  font-weight: 700;
  height: 48px;
  margin-top: 16px;
  min-width: 180px;
  outline: none;
  padding: 12px;
  transition: all .25s ease;

  &:hover {
    background-color: ${props => props.theme.colors.secondary3};
  }

  &:focus {
    background-color: ${props => props.theme.colors.secondary4};
  }

  @media (min-width: ${props => props.theme.breakpoints.md}) {

  }

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    width: 264px;
  }
`;

function Button(props) {
  const { text, className, style } = props;
  function handleClick(e) {
    if (!!props.handleClick) {
      props.handleClick()
      e.preventDefault();
    }
  }
  

  return <StyledButton className={className} onClick={e => handleClick(e)} style={style} type="button">{text}</StyledButton>;
}

export default withTheme(Button);